import { Badge } from '@/components/ui/badge';

interface ComparisonStatsProps {
  stats: {
    added: number;
    removed: number;
    unchanged: number;
  };
}

const ComparisonStats = ({ stats }: ComparisonStatsProps) => {
  const hasDifferences = stats.added > 0 || stats.removed > 0;

  return (
    <div className='flex items-center gap-2'>
      <h3 className='font-medium text-sm text-content-primary'>
        Comparison Results
      </h3>
      {hasDifferences ? (
        <div className='flex items-center gap-2'>
          {stats.removed > 0 && (
            <Badge
              variant='outline'
              className='bg-status-error/10 text-status-error border-status-error/30'
            >
              {stats.removed} Removed
            </Badge>
          )}
          {stats.added > 0 && (
            <Badge
              variant='outline'
              className='bg-status-success/10 text-status-success border-status-success/30'
            >
              {stats.added} Added
            </Badge>
          )}
        </div>
      ) : (
        <Badge
          variant='outline'
          className='bg-status-info/10 text-status-info border-status-info/30'
        >
          Identical
        </Badge>
      )}
    </div>
  );
};

export default ComparisonStats;
